import React, { useEffect, useRef } from "react";
import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";

type Props = {
  min?: number;
  max?: number;
  value: [number, number];
  onChange: (value: [number, number]) => void;
};

const ScoreRangeSlider: React.FC<Props> = ({
  min = 0,
  max = 100,
  value,
  onChange,
}) => {
  const sliderRef = useRef<HTMLDivElement>(null);
  const sliderInstance = useRef<ReturnType<typeof noUiSlider.create> | null>(null);

  useEffect(() => {
    if (!sliderRef.current) return;

    sliderInstance.current = noUiSlider.create(sliderRef.current, {
      start: value,
      connect: true,
      range: { min, max },
      step: 1,
    });

    sliderInstance.current.on("update", (values: (string | number)[]) => {
      const newValues: [number, number] = [
        Math.round(Number(values[0])),
        Math.round(Number(values[1])),
      ];
      onChange(newValues);
    });

    return () => {
      sliderInstance.current?.destroy();
    };
  }, []);

  //  Sync when value changes from outside
  useEffect(() => {
    if (sliderInstance.current) {
      const current = sliderInstance.current.get() as string[];

      const currentValues: [number, number] = [
        Number(current[0]),
        Number(current[1]),
      ];

      // prevent infinite loop
      if (
        currentValues[0] !== value[0] ||
        currentValues[1] !== value[1]
      ) {
        sliderInstance.current.set(value);
      }
    }
  }, [value]);

  return (
    <div>
      <div ref={sliderRef}></div>

      <div className="d-flex justify-content-between mt-2 text-muted fs-7">
        <span>Min: {value[0]}</span>
        <span>Score</span>
        <span>Max: {value[1]}</span>
      </div>
    </div>
  );
};

export default ScoreRangeSlider;